// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_4dd3b1fd","image":"_ef36528e"};